import { Box } from '@wix/design-system';
import React from 'react';
import { SearchBox } from '@wix/app-market-components';
import { useSearchBoxActions } from '../../search-box/hooks/search-box-actions';
import { useEssentials, useSiteContext } from '@wix/app-market-core';

export function SidebarHeader() {
  const { experiments } = useEssentials();
  const { languageCode } = useSiteContext();
  const { onSelect, onChange, onFocus, onEnterPressed } = useSearchBoxActions(
    'sidebar',
    'search-bar-sidebar',
  );

  return (
    <Box direction="vertical" paddingTop="8px">
      <Box
        align="center"
        verticalAlign="middle"
        padding="18px 20px 6px"
        paddingBottom="10px"
      >
        <Box width="213px">
          <SearchBox
            dataHook="search-box-sidebar-header"
            onChange={onChange}
            onSelect={onSelect}
            onEnterPressed={onEnterPressed}
            onFocus={onFocus}
            languageCode={languageCode}
            experiments={experiments}
            size="small"
            border="round"
            dropdownWidth="380px"
          />
        </Box>
      </Box>
    </Box>
  );
}
